// import DsfDefaultHomeHeader from './homeHeader';
// import DsfDefaultHomeFooter from './homeFooter';
// import DsfDefaultHomeAsideMenu from './homeAsideMenu';
// import DsfDefaultHomeMenu from './aside/menu';
// import DsfDefaultHomeMenuItem from './aside/menuItem';
// import DsfDefaultHomeBreadcrumb from './homeBreadcrumb';
// import DsfDefaultHomeHeaderMenuChildren from './homeHeaderMenuChildren';

const DsfDefaultHomeMenu = Vue.defineAsyncComponent(() => import(/* webpackChunkName: "home_default_template" */ "./aside/menu"));
const DsfDefaultHomeMenuItem = Vue.defineAsyncComponent(() => import(/* webpackChunkName: "home_default_template" */ "./aside/menuItem"));
const DsfDefaultHomeAsideMenu = Vue.defineAsyncComponent(() => import(/* webpackChunkName: "home_default_template" */ "./homeAsideMenu"));
const DsfDefaultHomeHeader = Vue.defineAsyncComponent(() => import(/* webpackChunkName: "home_default_template" */ "./homeHeader"));
const DsfDefaultHomeFooter = Vue.defineAsyncComponent(() => import(/* webpackChunkName: "home_default_template" */ "./homeFooter"));
const DsfDefaultHomeBreadcrumb = Vue.defineAsyncComponent(() => import(/* webpackChunkName: "home_default_template" */ "./homeBreadcrumb"));
const DsfDefaultHomeHeaderMenuChildren = Vue.defineAsyncComponent(() => import(/* webpackChunkName: "home_default_template" */ "./homeHeaderMenuChildren"));

export { DsfDefaultHomeMenu, DsfDefaultHomeMenuItem, DsfDefaultHomeAsideMenu, DsfDefaultHomeHeader, DsfDefaultHomeFooter, DsfDefaultHomeBreadcrumb, DsfDefaultHomeHeaderMenuChildren };

export default {
  install(Vue) {
    Vue.component("DsfDefaultHomeMenu", DsfDefaultHomeMenu);
    Vue.component("DsfDefaultHomeMenuItem", DsfDefaultHomeMenuItem);
    Vue.component("DsfDefaultHomeAsideMenu", DsfDefaultHomeAsideMenu);
    Vue.component("DsfDefaultHomeHeader", DsfDefaultHomeHeader);
    Vue.component("DsfDefaultHomeFooter", DsfDefaultHomeFooter);
    Vue.component("DsfDefaultHomeBreadcrumb", DsfDefaultHomeBreadcrumb);
    Vue.component("DsfDefaultHomeHeaderMenuChildren", DsfDefaultHomeHeaderMenuChildren);
  }
};
